import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowShareLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowShareLeft"><Path d="M11.9993 7.51462V1.77344L0.494141 12.0003L11.9993 22.2271V16.4791C15.3541 16.4431 17.2714 16.8169 18.4896 17.426C19.7526 18.0574 20.3801 18.9978 21.1049 20.4475L22.9993 20.0003C22.9993 15.716 22.3849 12.4932 20.4187 10.3814C18.5906 8.41778 15.7988 7.62727 11.9993 7.51462Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowShareLeft;
